// GENERATED FILE — do not edit. Source of truth: contracts/. Regenerate: node scripts/sync-contracts.mjs

import { z } from 'zod';
// Runtime validation: every named type above has a matching `<Name>Schema` zod export — the
// exact schema the backend validates with (story 2-92), so forms can `.parse()`/`.safeParse()`
// against it instead of hand-rolling checks. `.refine()` cross-field rules are preserved
// verbatim; the refine() error MESSAGE is not — the server owns user-facing text.

export type CursorList = {
  items: Array<unknown>;
  nextCursor: string | null;
  total?: number | undefined;
};
export const CursorListSchema = z.object({
  items: z.array(z.unknown()),
  nextCursor: z.string().nullable(),
  total: z.number().int().optional(),
}).strict();

export type ListQuery = {
  cursor?: string | undefined;
  limit?: number | undefined;
  sort?: string | undefined;
};
export const ListQuerySchema = z.object({
  cursor: z.string().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
  sort: z.string().min(1).optional(),
});
